"use client";

import { motion } from "framer-motion";
import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  return (
    <>
      {/* Glassmorphism Overlay - fades out on page load */}
      <motion.div
        initial={{ opacity: 1 }}
        animate={{ opacity: 0 }}
        transition={{ duration: 0.6, delay: 0.05, ease: "easeOut" }}
        className="fixed inset-0 z-[200] pointer-events-none"
        style={{
          background: "linear-gradient(135deg, rgba(142, 124, 94, 0.25) 0%, rgba(26, 26, 26, 0.3) 100%)",
          backdropFilter: "blur(30px)",
          WebkitBackdropFilter: "blur(30px)",
        }}
      />

      {/* Page Content - ONLY opacity animation (filter/transform breaks fixed positioning) */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: 0.4,
          delay: 0.15,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        {children}
      </motion.div>
    </>
  );
}
